<template>
    <section>
        <div style="width: 100%">
            <span class="one">รหัส-ชื่อพนักงาน</span>
            <span class="two">วันที่</span>
            <span class="three">เงินเดือน</span>
            <span class="four">เบี้ยขยัน</span>
            <span class="five">ล่วงเวลา</span>
            <span class="six">ทำวันหยุด</span>
            <span class="seven">เงินค้างได้รับ</span>
            <span class="eight">รวมเงินได้</span>
            <span class="nine" v-for="list in arr_th">
                {{ list }}
            </span>
        </div>
        <br>
        <div style="width: 100%" v-for="item in data">
            <span class="one">{{ item.employee_no + ' ' + item.employee }}</span>
            <span class="two">{{ item.payment_date | formatDate }}</span>
            <span class="three">{{ item.income_salary + item.income_half_day_work | amount }}</span>
            <span class="four">{{ item.income_benefits_bonus | amount }}</span>
            <span class="five">{{ item.income_overtime_one_half | amount }}</span>
            <span class="six">{{ item.income_holiday | amount }}</span>
            <span class="seven">{{ item.income_accrued | amount }}</span>
            <span class="eight">{{ item.total_income | amount }}</span>
            <template v-for="x in arr_cost_list">
                <span class="nine">{{ item[x] | amount }}</span>
            </template>
            <br>
        </div>
    </section>
</template>

<script>
export default {
    name: "ContentToPrint",
    props: {
        data: Array,
        date: Array,
        employee: Array,
        department: Array,
        type: Array,
    },
    data() {
        return {
            arr_th: [
                'ปกสค.',
                'รค.',
                'ชห.',
                'ขง.',
                'บลห.',
                'B.',
                'สห.',
                'บพนง.',
                'ปกสห.',
                'ภษ.',
                'ปกห.',
                'บรก.',
                'ทศ.',
                'ขส.',
                'กรย.',
                'อื่นๆ.',
                'รวมรายจ่าย',
                'สุทธิ',
            ],
            arr_cost_list: [
                'cost_social_security',
                'cost_cooperative_store',
                'cost_rental_fee',
                'cost_absence_from_work',
                'cost_advance',
                'cost_bank_charge',
                'cost_damages',
                'cost_employee_card',
                'cost_damage_security_deposit',
                'cost_personal_income_tax',
                'cost_room_security_deposit',
                'cost_service',
                'cost_phone',
                'cost_transport_fee',
                'cost_gas_car',
                'cost_other',
                'total_cost',
                'net_total'
            ],
        }
    },
    watch: {
        date: function (newVal, oldVal) {
            //console.log('Prop changed date: ', newVal, ' | was: ', oldVal)
        },
        employee: function (newVal, oldVal) {
            //console.log('Prop changed: employee', newVal, ' | was: ', oldVal)
        },
        department: function (newVal, oldVal) {
            //console.log('Prop changed: department', newVal, ' | was: ', oldVal)
        },
        type: function (newVal, oldVal) {
            //console.log('Prop changed: type', newVal, ' | was: ', oldVal)
        }
    }
}
</script>

<style scoped>
span {
    font-size: 10px;
    text-align: center;
    vertical-align: top;
}

span.one {
    width: 8%;
    display: inline-block;
    text-align: left;
}

span.two {
    width: 4%;
    display: inline-block;
}

span.three {
    width: 3%;
    display: inline-block;
}

span.four {
    width: 3%;
    display: inline-block;
}

span.five {
    width: 3%;
    display: inline-block;
}

span.six {
    width: 4%;
    display: inline-block;
}

span.seven {
    width: 3%;
    display: inline-block;
}

span.eight {
    width: 3%;
    display: inline-block;
}

span.nine {
    width: 3%;
    display: inline-block;
}

span.ten {
    width: 3%;
    display: inline-block;
}
</style>
